/***
 *
 *   PRICE PLANS
 *   Phase 10 — reference PricingSection card treatment; live usePlans() data.
 *
 **********/

import { Button, useNavigate, usePlans, Icon, cn } from 'components/lib';
import Style from './pricing.tailwind.js';
import { useTranslate } from 'app/translations';

export function PricePlans(props) {
    const navigate = useNavigate();
    const plans = usePlans();
    const { _t } = useTranslate();

    if (!plans.data) return false;

    const list = plans.data.raw?.plans || [];

    return (
        <section className={Style.plans}>
            {list.map((plan, index) => {
                const featured = index === 1 && list.length >= 2;

                return (
                    <div
                        key={plan.id}
                        className={cn(Style.plan, featured ? Style.planFeatured : Style.planDefault)}>
                        {featured && (
                            <div className={Style.popularPin}>
                                <span className={Style.popular}>{_t('pricing.popular')}</span>
                            </div>
                        )}

                        <div className={cn(Style.name, featured && Style.nameFeatured)}>{plan.name}</div>

                        <div className={cn(Style.price, featured && Style.priceFeatured)}>
                            {plan?.currency?.symbol}
                            {plan.price}
                            <small className={featured ? Style.intervalFeatured : Style.interval}>
                                {plan.interval && '/'}
                                {plan.interval}
                            </small>
                        </div>

                        <ul className={Style.featureList}>
                            {(plan.features || []).map((feature) => (
                                <li key={feature} className={Style.featureItem}>
                                    <Icon
                                        image="check"
                                        size={16}
                                        color="currentColor"
                                        className={featured ? Style.checkFeatured : Style.check}
                                    />
                                    <span className={featured ? Style.featureTextFeatured : Style.featureText}>
                                        {feature}
                                    </span>
                                </li>
                            ))}
                        </ul>

                        <Button
                            text={_t('signup.label')}
                            variant={featured ? 'accent' : 'secondary'}
                            fullWidth
                            className={Style.button}
                            action={() => navigate('/signup')}
                        />
                    </div>
                );
            })}
        </section>
    );
}
